import { combineEpics } from "redux-observable";

export const uiEpics = combineEpics();
